/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');

module.exports = Marionette.Behavior.extend({
  onBeforeShow: function() {
    var self = this;
    _.each(this.$el.find('.phone-format'), function(phone) {
      self.$(phone).on('beforeinput', function(e) {
        self.handleBeforeInput(e.originalEvent || e);
      });
      self.$(phone).on('input', function(e) {
        self.formatField(e.target);
      });
      self.formatField(phone);
    });
  },

  handleBeforeInput: function(e) {
    var inputType = e.inputType || '';
    if (inputType.indexOf('insert') !== 0) {
      return; // deletions, undo/redo, etc. pass through; input handler cleans up
    }

    var data = e.data;
    if ((data === null || data === undefined) && e.dataTransfer) {
      data = e.dataTransfer.getData('text');
    }
    if (data === null || data === undefined) {
      return;
    }

    var field = e.target;
    var value = field.value;
    var supportsCaret = typeof field.selectionStart === 'number';
    var start = supportsCaret ? field.selectionStart : value.length;
    var end = supportsCaret ? field.selectionEnd : value.length;

    // Digits on either side of the selection (the selection itself is replaced).
    var before = value.slice(0, start).replace(/\D/g, '');
    var after = value.slice(end).replace(/\D/g, '');
    var incoming = data.replace(/\D/g, '');

    if (data === incoming && before.length + incoming.length + after.length <= 10) {
      return;
    }

    e.preventDefault();
    var merged = (before + incoming + after).slice(0, 10);
    var formatted = this.buildValue(merged);
    this.$(field).val(formatted);

    if (supportsCaret) {
      var digitsBeforeCaret = Math.min(before.length + incoming.length, 10);
      var caret = this.caretAfterDigits(formatted, digitsBeforeCaret);
      field.setSelectionRange(caret, caret);
    }
  },

  // Strip everything that isn't a digit, cap at 10, lay out as xxx-xxx-xxxx.
  buildValue: function(raw) {
    var digits = String(raw)
      .replace(/\D/g, '')
      .slice(0, 10);
    if (digits.length > 6) {
      return digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6);
    }
    if (digits.length > 3) {
      return digits.slice(0, 3) + '-' + digits.slice(3);
    }
    return digits;
  },

  formatField: function(field) {
    var $field = this.$(field);
    var oldValue = $field.val();
    var formatted = this.buildValue(oldValue);

    if (formatted === oldValue) {
      return;
    }

    var supportsCaret = typeof field.selectionStart === 'number';
    var digitsBeforeCaret = supportsCaret ? oldValue.slice(0, field.selectionStart).replace(/\D/g, '').length : 0;

    $field.val(formatted);

    if (supportsCaret) {
      var caret = this.caretAfterDigits(formatted, digitsBeforeCaret);
      field.setSelectionRange(caret, caret);
    }
  },

  // Index just after the Nth digit, skipping a dash right after it
  // so the caret lands ready for the next digit.
  caretAfterDigits: function(str, n) {
    if (n <= 0) {
      return 0;
    }
    var count = 0;
    for (var i = 0; i < str.length; i++) {
      if (/\d/.test(str.charAt(i))) {
        count++;
        if (count === n) {
          var pos = i + 1;
          return str.charAt(pos) === '-' ? pos + 1 : pos;
        }
      }
    }
    return str.length;
  }
});
